<template>
  <div class="class-schedule__list">
    <div
      v-for="slot in scheduleCards"
      :key="slot.id"
      class="class-schedule__item"
    >
      <ClassCard
        :class-data="slot.cardData"
        :show-collapse="false"
      >
        <template #cta>
          <ClassJoinButton
            :class-data="classData"
            :selected-slot="slot.payload"
            :label="$t('Book now')"
            :block="true"
          />
        </template>
      </ClassCard>
    </div>
  </div>
</template>

<script>
import ClassCard from '@/components/classes/ClassCard.vue';
import ClassJoinButton from '@/components/classes/ClassJoinButton.vue';

export default {
  name: 'ClassScheduleList',
  components: {
    ClassCard,
    ClassJoinButton,
  },
  props: {
    scheduleCards: {
      type: Array,
      default: () => [],
    },
    classData: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
.class-schedule__list {
  display: flex;
  gap: 1.6rem;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 0.8rem;
  scroll-snap-type: x proximity;
  flex-wrap: nowrap;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.class-schedule__list::-webkit-scrollbar {
  display: none;
}

.class-schedule__item {
  flex: 0 0 calc((100% - 3.2rem) / 3);
  max-width: calc((100% - 3.2rem) / 3);
  min-width: 24rem;
  scroll-snap-align: start;
}

/* Ensure upcoming class cards use black text while keeping badge/button styling */
.class-schedule__item :deep(.class-card__title),
.class-schedule__item :deep(.class-card__title-link),
.class-schedule__item :deep(.class-card__therapist),
.class-schedule__item :deep(.class-card__therapist-link),
.class-schedule__item :deep(.class-card__info-item),
.class-schedule__item :deep(.class-card__price-label),
.class-schedule__item :deep(.class-card__price-amount) {
  color: #000000;
}

@media (max-width: 1024px) {
  .class-schedule__item {
    flex-basis: min(32rem, 80%);
    max-width: min(32rem, 80%);
  }
}

@media (max-width: 640px) {
  .class-schedule__list {
    gap: 1.2rem;
  }

  .class-schedule__item {
    min-width: 22rem;
    flex-basis: 85%;
    max-width: 85%;
  }
}
</style>
